import { openFacebookPost } from './openFacebookPost';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { StandardPostDetailed } from 'app/types/StandardPostDetailed';
import { openBlank } from 'utils/url';

export const getSocialMediaPostOpener = (
  pageType: number,
  post: StandardPostDetailed,
) => {
  switch (pageType) {
    case TYPE.FACEBOOK:
      return () => openFacebookPost(post.linkId);
    case TYPE.INSTAGRAM:
    case TYPE.LINKEDIN:
      return post.link ? () => openBlank(post.link!) : undefined;
    default:
      return undefined;
  }
};
